import { observer } from "mobx-react-lite";
import ILocation from "../../interfaces/ILocation";
import { formatDateForInput, formatNumber, formatPrice } from "../../utils/utils";
import EditableGrid, { InputType } from "./EditableGrid";

function LocationsEditableGrid({ values, onChange }: ILocationsEditableGridProps) {
    return (
        <EditableGrid
            values={values}
            headers={[
                {
                    align: "left",
                    titleStrings: ["SITE NAME"],
                    getValue: item => item.siteName!,
                    getLabel: item => item.siteName!,
                    setValue: (item, value: any) => {
                        item.siteName = value;
                    },
                    valueType: InputType.Text,
                },
                {
                    align: "left",
                    titleStrings: ["ADDRESS"],
                    getValue: item => item.address!,
                    getLabel: item => item.address!,
                    setValue: (item, value: any) => {
                        item.address = value;
                    },
                    valueType: InputType.Text,
                },
                {
                    align: "left",
                    titleStrings: ["ZONING"],
                    getValue: item => item.zoning!,
                    getLabel: item => item.zoning!,
                    setValue: (item, value: any) => {
                        item.zoning = value;
                    },
                    valueType: InputType.Text,
                },
                {
                    align: "left",
                    titleStrings: ["BUILDING SIZE"],
                    getValue: item => item.buildingSize!,
                    getLabel: item => item.buildingSize ? formatNumber(item.buildingSize) : "",
                    setValue: (item, value: any) => {
                        item.buildingSize = value;
                    },
                    valueType: InputType.Number,
                },
                {
                    align: "left",
                    titleStrings: ["LAND SIZE"],
                    getValue: item => item.landSize,
                    getLabel: item => item.landSize ? formatNumber(item.landSize) : "",
                    setValue: (item, value: any) => {
                        item.landSize = value;
                    },
                    valueType: InputType.Number,
                },
                {
                    align: "left",
                    titleStrings: ["OWNER"],
                    getValue: item => item.ownerName!,
                    getLabel: item => item.ownerName!,
                    setValue: (item, value: any) => {
                        item.ownerName = value;
                    },
                    valueType: InputType.Text,
                },
                {
                    align: "left",
                    titleStrings: ["DATE SOLD"],
                    getValue: item => formatDateForInput(item.dateSold),
                    getLabel: item => item.dateSold ? formatDateForInput(item.dateSold) : "",
                    setValue: (item, value: any) => {
                        item.dateSold = value;
                    },
                    valueType: InputType.Date,
                },
                {
                    align: "left",
                    titleStrings: ["SALE PRICE"],
                    getValue: item => item.salePrice!,
                    getLabel: item => !!item.salePrice ? formatPrice(item.salePrice) : "",
                    setValue: (item, value: any) => {
                        item.salePrice = value;
                    },
                    valueType: InputType.Number,
                },
                {
                    align: "left",
                    titleStrings: ["OWNER ADDRESS"],
                    getValue: item => item.ownerAddress!,
                    getLabel: item => item.ownerAddress!,
                    setValue: (item, value: any) => {
                        item.ownerAddress = value;
                    },
                    valueType: InputType.Text,
                },
                {
                    align: "left",
                    titleStrings: ["NOTES"],
                    getValue: item => item.notes!,
                    getLabel: item => item.notes!,
                    setValue: (item, value: any) => {
                        item.notes = value;
                    },
                    valueType: InputType.Text,
                },
            ]}
            getId={item => item.id}
            onChange={onChange}
        />
    );
}

export default observer(LocationsEditableGrid);

interface ILocationsEditableGridProps {
    values: ILocation[];
    onChange: (location: ILocation) => void;
}